import React from 'react'
import { connect } from 'react-redux'
import { TidewaysContext } from '../../app/context'
import { Entity } from '../../app/entity'
import Navigator from '../../app/navigator'
import { Report } from '../../domain/Report'
import BoxBody from '../../helper/boxBody'
import Loading from '../../helper/loading'
import { RangeSelectorInterface } from '../../history/RangeSelectorInterface'
import { rangeSelectorPerformanceView } from '../../history/rangeSelectorPerformanceView'
import { ApplicationState } from '../../redux/ApplicationState'
import ServiceEnvironmentNavigation from '../../service-environment-navigation'
import HistoryRangeSelector from '../graph/history_range'
import TimeRangeSelector from '../time_range'

interface OwnProps {
    data?: Report<any> | null
    loading: boolean
    daysOnScale: number
    selector: RangeSelectorInterface
    dataFixedTimezone: string
    showGraph: boolean
    allServices: boolean
}

interface StateProps {
    tidewaysContext: TidewaysContext
    navigator: Navigator
    parameters?: {
        [key: string]: string
    }
}

type Props = OwnProps & StateProps

interface State {
    compactServices: boolean
    compactEnvironments: boolean
}
export class TimeExplorerComponent extends React.Component<Props, State> {
    public static defaultProps = {
        showGraph: true,
        allServices: false,
    }

    public state: State = {
        compactServices: false,
        compactEnvironments: false,
    }

    public render() {
        let loading = this.props.loading
        const selector = this.selector()

        if (!this.props.showGraph) {
            loading = false
        }

        if (!this.props.data && this.props.showGraph) {
            return (
                <div>
                    <Loading {...this.props} height={selector.supportsGraph() ? 139 : 40} boxStyle={{ marginBottom: '0' }} />
                </div>
            )
        }

        return (
            <div className="monitor time-explorer">
                <div className="box box-default" style={{ marginBottom: '0' }}>
                    <BoxBody {...this.props} loading={loading}>
                        <ServiceEnvironmentNavigation
                            data={this.props.data}
                            selector={this.selector()}
                            allServices={this.props.allServices}
                        >
                            {this.props.showGraph ? (
                                <div className="pull-right">
                                    <TimeRangeSelector rangeSelector={selector} />
                                </div>
                            ) : null}
                        </ServiceEnvironmentNavigation>
                        {selector.supportsGraph() && this.props.data && this.props.showGraph ? (
                            <HistoryRangeSelector
                                history={this.props.data}
                                renderScrollbar={this.props.tidewaysContext.application.retentionDays > 1}
                                daysOnScale={this.props.daysOnScale}
                                selector={selector}
                                dataFixedTimezone={this.props.dataFixedTimezone}
                            />
                        ) : null}
                    </BoxBody>
                </div>
            </div>
        )
    }

    public selector = () => this.props.selector || rangeSelectorPerformanceView(this.props.tidewaysContext, this.props.navigator)
}

export default connect<StateProps, OwnProps>((globalState: ApplicationState, props: OwnProps) => {
    const route = globalState.tidewaysContext.route.parameters
    const history =
        (route?.organization ? globalState.monitor.baseServiceHistory[route.organization + '/' + route.application] : null) || new Entity()

    return {
        tidewaysContext: globalState.tidewaysContext,
        navigator: new Navigator(globalState.tidewaysContext.route),
        parameters: globalState.tidewaysContext.route.parameters,
        ...history,
        ...props,
    }
})(TimeExplorerComponent)
